import { makeStyles } from "@material-ui/core";

export const GlobalDialerV2Styles = makeStyles((theme) => ({
    globalDialerV2Wrapper: {
        display: "flex !important",
        flexDirection: "column !important",
        gap: "12px !important",
        padding: '16px !important',

        "& .DefaultScreenWrapper": {
            display: "flex !important",
            alignItems: "center !important",
            justifyContent: "flex-end !important",
            gap: '16px !important',

            "& .callFromWrapper": {
                fontSize: '14px !important',
                fontWeight: '600 !important',
                color: "#ffffff !important",
                display: "flex !important",
                alignItems: "center !important",
                gap: '8px !important',
            },

            "& .numberButton": {
                fontSize: '12px !important',

                color: "#ffffff !important",
                background: "#3D50FF !important",

                padding: "4px 12px !important",
                borderRadius: '8px !important',
                cursor: "pointer !important",
            }
        },

        "& .callButton":{
            fontWeight: "600 !important",

            backgroundColor: "#34F28B !important",
            color: "#212140 !important",

            borderRadius: "4px !important",
            textTransform: "capitalize !important",

            "&:hover": {
                backgroundColor: "#34F28B !important",
            },

            "& svg": {
                color: "#212140 !important",
            },

            "&.active": {
                backgroundColor: "#FF264A !important",
            },

            "&.MuiButton-contained.Mui-disabled": {
                backgroundColor: "rgba(0, 0, 0, 0.12) !important",
            }
        },

        "& .outlinedButton": {
            color: "#fff !important",
            borderColor: "#fff !important",
            textTransform: "capitalize !important",
            "&:hover, &:focus": {
                backgroundColor: "transparent !important",
            },
        },

        "& .contactList": {
            // padding: 12,
            // borderRadius: 8,

            "& .scrollBar": {
                maxHeight: '312px !important',
                overflowY: 'auto !important',
                scrollbarWidth: 'thin !important',
                scrollbarColor: '#CBD5E1 transparent',
                '&::-webkit-scrollbar': {
                    width: '8px !important',
                },
            },

            "& .contactItem": {
                display: "flex !important",
                justifyContent: "space-between !important",
                alignItems: "center !important",

                backgroundColor: "#FFFFFF !important",

                border: "1px solid #DEE0E3 !important",
                borderRadius: '4px !important',
                gap: '4px !important',
                padding: "8px 12px !important",
                cursor: "pointer !important",

                "&:nth-child(odd)": {
                    backgroundColor: "#F2F3F5 !important",
                },

                // "&:not(:last-child)": {
                //     marginBottom: 0,
                // },

                "& .leftSide":{
                    display: "flex !important",
                    alignItems: "center !important",
                    gap: '8px !important',
                },

                "& .itemTitle": {
                    fontSize: '14px !important',
                    fontWeight: '600 !important',
                    color: "#212140 !important",
                    flex: '1 !important',
                    maxWidth: '140px !important',
                    overflow: 'auto !important',
                    whiteSpace: 'nowrap !important',
                    marginRight: '2px !important',
                    scrollbarWidth: 'none !important',
                },
                "& .itemPhone": {
                    fontSize: '14px !important',
                    fontWeight: '600 !important',
                    color: "#3D50FF !important",
                },

                '& .MuiIconButton-root': {
                    padding: '0px !important'
                },

                '&.selected': {
                    outline: '#a15cff solid 2px !important',
                    backgroundColor: '#d6d6d6 !important'
                },

                '& svg': {
                    color: 'rgba(0, 0, 0, 0.54) !important'
                }
            },

            "& .DefaultScreenWrapper": {
                justifyContent: "flex-end !important",
                marginTop: '12px !important',
            },
        },

        "& .globalDialerHeader": {
            display: "flex !important",
            alignItems: "center !important",
            gap: "10px",

            "& .searchInput": {
                "& input::placeholder": {
                    fontSize: "10.7px !important",
                    position: "absolute !important",
                    top: "10px !important"
                }
            },
            "& .headerActionButton": {
                display: "flex !important",
                alignItems: "center !important",
                justifyContent: "center !important",
                color: '#000000de !important',
                background: "#ECF4FF !important",
                padding: "8px",
                borderRadius: "4px !important",

                cursor: "pointer !important",

                "&:hover": {
                    background: "#ECF4FF !important",
                },
                "& svg": {
                    color: "#212140 !important",
                },
            }
        },

        "& .globalDialerKeypadTray": {
            backgroundColor: "#ffffff !important",
            borderRadius: "8px !important",
            paddingTop: "20px !important",
            "& .dialNumberWrapper": {
              display: "flex !important",
              justifyContent: 'center !important',
            },
            "& .dialedNumber": {
                textAlign: "center !important",
                margin: '0 auto !important',
                fontSize: "20px !important",
                paddingBottom: "16px !important",
                border: '0px !important',
                maxWidth: '200px !important',

                '&:focus-visible, &:focus': {
                    outline: 'none !important',
                    border: '0px !important',
                    boxShadow: 'none !important'
                }
            },
        },

        "& .globalDialerKeypad": {
            display: "grid !important",
            gridTemplateColumns: "repeat(3, 1fr) !important",
            gap: "16px !important",

            // height: 312,

            padding: "0px 40px 40px !important",

            "& .keypadItem": {
                height: '60px !important',
                width: '60px !important',

                background: "#E8E8E8 !important",
                color: '#212140 !important',
                fontSize: "14px !important",
                justifySelf: "center !important",
                
 
                padding: "4px !important",
                borderRadius: "50% !important",
                
                display: "flex !important",
                flexDirection: "column !important",
                alignItems: "center !important",
                justifyContent: "center !important",
                cursor: "pointer !important",

                "& .keypadNumber": {
                    fontSize: '24px !important',
                    fontWeight: '600 !important',
                    lineHeight: "22px !important"
                },
                "& .keypadLetters": {
                    fontSize: '9px !important',
                    fontWeight: '600 !important',
                },

                "&:hover, &:active": {
                    backgroundColor: 'rgb(33 33 64 / 18%) !important',
                }
            },

            "& .keypadSelect": {
                gridColumnStart: '1 !important',
                gridColumnEnd: '-1 !important'
            }
        },


        "& .selectedContactWrapper": {
            "& .contactDetails": {
                position: "relative !important",

                display: "flex !important",
                flexDirection: "column !important",
                alignItems: "center !important",
                justifyContent: "space-between !important",
                height: '235px !important',

                padding: "8px 12px 24px 12px !important",
                borderRadius: '8px !important',
                backgroundColor: "#ECF4FF !important",

                marginBottom: '22px !important',

                "& .closeButton": {
                    position: "absolute !important",
                    top: '16px !important',
                    right: '16px !important',
                    cursor: "pointer !important",
                },

                "& .contactInfo": {
                    display: "flex !important",
                    flexDirection: "column !important",
                    alignItems: "center !important",

                    padding: "8px 12px !important",

                    "& .avatarWrapper": {
                        position: "relative !important",

                        "& .avatar": {
                            position: "absolute !important",
                            top: '18px !important',
                            left: '18px !important',
                        },
                    },

                    "& .avatar": {
                        width: '50px !important',
                        height: '50px !important',

                        fontWeight: '600 !important',
                        fontSize: '24px !important',

                        backgroundColor: "#fff !important",
                        color: "#757F8E !important",

                        marginBottom: '8px !important',
                    },

                    "& .contactName": {
                        fontSize: '20px !important',
                        fontWeight: '600 !important',
                        color: "#757F8E !important",
                    },
                    "& .contactPhone": {
                        fontSize: '24px !important',
                        fontWeight: '600 !important',
                        color: "#000000 !important",
                    },
                },
                
                "& .recordingWrapper": {
                    color: "#757F8E !important",
                    fontSize: '14px !important',
                    fontWeight: '600 !important',

                    display: "flex !important",
                    alignItems: "center !important",
                    justifyContent: "center !important",
                    gap: '4px !important',

                    padding: "3px 4px !important",
                    border: "1px solid #757F8E !important",

                    borderRadius: '8px !important',
                    marginTop: '8px !important',
                }


            },
            
            "& .connectedActions": {
                marginTop: '16px !important',
                "& .iconList": {
                    display: "flex !important",
                    alignItems: "center !important",
                    justifyContent: "center !important",
                    gap: '36px !important',

                    "&:not(:last-child)": {
                        marginBottom: '36px !important',
                    },

                    "& .iconWrapper": {
                        height: '44px !important',
                        width: '44px !important',
                        position: "relative !important",
                        
                        display: "flex !important",
                        alignItems: "center !important",
                        justifyContent: "center !important",

                        background: "#fff !important",
                        padding: "10px !important",
                        borderRadius: "50% !important",

                        cursor: "pointer !important",

                        "& .iconText": {
                            position: "absolute !important",
                            bottom: '-24px !important',
                            minWidth: "max-content !important"
                        }
                    },

                    "& .iconText": {
                        fontSize: '14px !important',
                        color: "#757F8E !important",
                    }
                }
            }
        },

        "& .callTransferWrapper": {
            "& .footerSection": {
                display: 'flex !important',
                alignItems: 'center !important',
                gap: '10px !important',

                '& .MuiButton-label': {
                    fontWeight: '700 !important'
                },

                '& .MuiButton-root': {
                    '&:disabled': {
                        opacity: '0.49 !important',
                        cursor: 'not-allowed !important'
                    }
                }
            }
        },

        '& .nonContactMessage': {
            fontSize: "10px !important",
            color: "#ddd2d2 !important",
            marginBottom: "4px !important",
            display: "block !important"
        },

        '& .callTransferWrapperBackdrop': {
            position: 'fixed !important',
            inset: '0',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },

        '& .callTransferContainer': {
            position: 'relative !important',
            zIndex: 1001,
            backgroundColor: "#222241 !important",
            width: '400px !important',
            borderRadius: '8px !important',
            display: "flex !important",
            flexDirection: "column !important",
            gap: "12px !important",
            padding: '16px !important',
        },

        "& .footerSectionKeypad": {
            display: 'flex !important',
            alignItems: 'center !important',
            gap: '10px !important',

            '& .MuiButton-label': {
                fontWeight: '700 !important'
            },

            '& .MuiButton-root': {
                '&:disabled': {
                    opacity: '0.49 !important',
                    cursor: 'not-allowed !important'
                }
            },
            "& .cold": {
                backgroundColor: "rgb(61, 80, 255) !important",
                textTransform: "capitalize !important",
            },
            "& .warm": {
                color: "#fff !important",
                borderColor: "#fff !important",
                textTransform: "capitalize !important",
                "&:hover, &:focus": {
                    backgroundColor: "transparent !important",
                },
            },
        }
    }
}));